import React, { createContext, useContext, ReactNode, useState } from 'react'

interface LeftNavContextType {
	isLeftNavCollapsed: boolean
	setIsLeftNavCollapsed: React.Dispatch<React.SetStateAction<boolean>>
	hasLeftNav: boolean
}

const LeftNavContext = createContext<LeftNavContextType | null>(null)

interface LeftNavProviderProps {
	children: ReactNode
}

export const LeftNavProvider: React.FC<LeftNavProviderProps> = ({
	children,
}) => {
	const [isLeftNavCollapsed, setIsLeftNavCollapsed] = useState(false)

	return (
		<LeftNavContext.Provider
			value={{
				isLeftNavCollapsed,
				setIsLeftNavCollapsed,
				hasLeftNav: true,
			}}
		>
			{children}
		</LeftNavContext.Provider>
	)
}

const noopLeftNav: LeftNavContextType = {
	isLeftNavCollapsed: false,
	setIsLeftNavCollapsed: () => {},
	hasLeftNav: false,
}

export const useLeftNav = (): LeftNavContextType => {
	return useContext(LeftNavContext) ?? noopLeftNav
}
